import * as types from "./actionTypes";

export function beginApiCall(api) {
  return { type: types.BEGIN_API_CALL, api };
}

export function apiCallError() {
  return { type: types.API_CALL_ERROR };
}
